module.exports = __webpack_public_path__ + "static/media/thenightly_app_download_image_2.7b48ec1c.png";